import React, { useMemo } from "react";
import SearchSelect from "../SearchSelect/SearchSelect";
import { formatIC, initials } from "../../utils/format";
import { phoneMatches } from "../../utils/phone";

const digits = (value) => value.replace(/\D/g, "");

// Patient search: matches on name, or on phone / IC number ignoring spaces and dashes.
const matchPatient = (item, q) => {
  const qDigits = digits(q);
  return (
    item.title.toLowerCase().includes(q) ||
    phoneMatches(item.phone, q) ||
    (qDigits.length >= 2 && digits(item.ic).includes(qDigits))
  );
};

const PatientPicker = ({
  patients,
  value,
  onChange,
  label = "Patient",
  placeholder = "Search name, phone or IC no.",
  emptyLabel,
  onRegister,
}) => {
  const items = useMemo(
    () =>
      patients.map((p) => ({
        id: p.id,
        title: p.name,
        subtitle: `${p.phone} · IC ${formatIC(p.ic)}`,
        avatar: initials(p.name),
        keywords: p.name,
        phone: p.phone,
        ic: p.ic || "",
      })),
    [patients]
  );
  return (
    <SearchSelect
      items={items}
      value={value}
      onChange={onChange}
      label={label}
      placeholder={placeholder}
      hint={emptyLabel}
      matcher={matchPatient}
      emptyText={(q) =>
        onRegister
          ? `No patient matches "${q}".`
          : `No patient matches "${q}". Check the spelling or try the phone or IC number.`
      }
      onCreate={onRegister}
      createLabel="Register new patient"
    />
  );
};

export default PatientPicker;
